<template>
    <div id="split">
        <a-modal
            :title="$t('pubGicSet.Split')"
            :visible="visible"
            @cancel="handleCancelSplit"
            width="60%">
            <template slot="footer">
                <a-button type="primary" size="small" @click="saveMoveSplit">{{$t('publicLang.Save')}}</a-button>
            </template>
            <a-row style="margin: 4px 0">
                <img class="sbxs"  @click="addSplitEvt" src="../../../../assets/img/ss-add.png" width="22" height="22">
                <img class="sbxs" style="margin-left: 4px;" @click="deleSplit" src="../../../../assets/img/ss-delete.png" width="22" height="22">
            </a-row>
            <a-row>
                <div id="movesplitTable">
                    <vxe-table
                        border
                        show-overflow
                        ref="moveSplit"
                        max-height="350"
                        size="mini"
                        :data="tableData">
                        <vxe-table-column type="checkbox" width="60" disabled></vxe-table-column>
                        <vxe-table-column field="recQty" :title="$t('pubGicSet.RecQty')">
                            <template v-slot="{ row }">
                                <a-input-number size="small" @change="changeNumberRecqty" :placeholder="$t('pubGicSet.RecQty')" :min="0" v-model="row.avQty" style="width: 100%;"/>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="location" :title="$t('pubGicSet.Location')">
                            <template v-slot="{ row }">
                                <!--<a-input v-model="row.location" placeholder="Location"  v-if="row.disabled"/>-->

                                <a-auto-complete
                                        style="width: 100%"
                                        @search="searchMovehandleSearch"
                                        :placeholder="$t('pubGicSet.ToLocation')"
                                        size="small"
                                        v-model="row.locationCode"
                                >
                                    <template slot="dataSource">
                                        <a-select-option v-for="item in moveCompleteData"  :key="item.locationCode" :value="item.locationName">{{item.locationName}}</a-select-option>
                                    </template>
                                </a-auto-complete>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        data(){
            return {
                visible: false,
                tableData: [],
                sumecQtyRnum: 0,
                paramsMove: {},
                moveCompleteData: []
            }
        },
        methods:{
            searchMovehandleSearch(val){
                if(val.length < 4){
                    return
                }
                let params = {
                    whsCode: this.paramsMove.waseCode,
                    keyword: val,
                }
                ajax.post(api.INVENTORYLOCATION,params).then(res=>{
                    this.moveCompleteData = res.data
                })
            },
            handleCancelSplit(){
                this.visible = false
            },
            show(val){
                this.paramsMove = val
                this.visible = true
                let data = val.invVos

                data.disabled = true
                this.sumecQtyRnum = data.avQty
                let arr =[]
                arr.push(data)
                this.tableData = arr
                setTimeout(()=>{
                    this.$nextTick(()=>{
                        let elInput = $('#movesplitTable>.vxe-table>.vxe-table--body-wrapper>.vxe-table--body>tbody').children().children('td:eq(0)').find('.vxe-cell').find('.vxe-checkbox').find('input')
                        let elspan = $('#movesplitTable>.vxe-table>.vxe-table--body-wrapper>.vxe-table--body>tbody').children().children('td:eq(0)').find('.vxe-cell').find('.vxe-checkbox').find('span')
                        let elLable = $('#movesplitTable>.vxe-table>.vxe-table--body-wrapper>.vxe-table--body>tbody').children().children('td:eq(0)').find('.vxe-cell').find('.vxe-checkbox')
                        elLable.addClass('is--disabled')
                        elInput.attr('disabled', true)
                        elspan.addClass('vxe-checkbox--icon')
                    })
                }, 200)
            },
            addSplitEvt(){
                this.tableData.push({avQty: 0, locationCode: null,disabled: false})
            },
            changeNumberRecqty(val){
                let num = this.sumecQtyRnum
                let delNum = 0
                let t = this.tableData
                for(let i in t){
                    if(!t[i].disabled){
                        if(parseFloat(val).toString() == 'NaN'){
                            t[i].avQty = 0
                            return
                        }else{
                            delNum =  delNum + t[i].avQty
                            if(delNum > num){
                                t[i].avQty = 0
                                return
                            }
                        }
                    }
                }
                if(delNum > num){
                    this.$customMessage.error(this.$t('publicLang.NotAllowToOverReceive'));
                    return
                }
                this.tableData[0].avQty = num - delNum
            },
            deleSplit(){
                let updateRecords = this.$refs.moveSplit.getCheckboxRecords()
                if(updateRecords.length > 0){
                    let t = 0
                    for(let i in updateRecords){
                        t = t + updateRecords[i].avQty
                    }
                    this.tableData[0].avQty = this.tableData[0].avQty + t
                    this.$refs.moveSplit.removeCheckboxRow()
                }else{
                    this.$customMessage.error(this.$t('publicLang.PleaseSltAtleast'));
                }
            },
            saveMoveSplit(){
                let arr = []
                let delNum = 0
                let t = this.tableData
                for(let i in t){
                    if(t[i].locationCode == '' || t[i].locationCode == null){
                        this.$customMessage.error(this.$t('pubGicSet.LocationISrequired'));
                        return
                    }
                    if(!t[i].disabled){
                        delNum =  delNum + t[i].avQty
                    }
                    arr.push({uid: this.paramsMove.invVos.uid,qty: t[i].avQty,toLocation: t[i].locationCode})
                }
                if(delNum > this.sumecQtyRnum){
                    this.$customMessage.error(this.$t('publicLang.NotAllowToOverReceive'));
                    return
                };
                let typeMarkstr = ''
                if(this.paramsMove.markStr == 'puatWay'){
                    typeMarkstr = 'invMoveDetail'
                }else{
                    typeMarkstr = this.paramsMove.markStr
                }
                let params = {
                    headerUid: this.paramsMove.headerUid,
                    userSqlDto:this.paramsMove.userSqlDto,
                    invVos: arr,
                    markStr: typeMarkstr  // invMoveDetail => move invAdjDetail=> adjust
                }
                ajax.post(api.INVDETAILPUB,params).then(res=>{
                    if(res.code == 200){
                        ajax.get(api.INVENTORYINVMOVE,{ uid: this.paramsMove.headerUid }).then(res=>{
                            this.$emit('splitMove', res.data)
                        })
                        this.visible = false
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.error(res.msg);
                        this.visible = false
                    }
                })
            }
        }
    }
</script>